import { render, staticRenderFns } from "./VcitaSwitch.vue?vue&type=template&id=628f0754&scoped=true"
import script from "./VcitaSwitch.vue?vue&type=script&lang=js"
export * from "./VcitaSwitch.vue?vue&type=script&lang=js"
import style0 from "./VcitaSwitch.vue?vue&type=style&index=0&id=628f0754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f0754",
  null
  
)

export default component.exports